import React from "react";
import styled from 'styled-components';
import Button from '../../../atoms/button';

const Container = styled.div`
  border-radius: 10px;
  align-self: center;
  display: flex;
  flex-direction: column;
  width: 500px;
  padding: 15px;
  background-color: white;
  border: 1px solid #e7e6e6;
  box-shadow: 0 1px 3px 0 rgba(0,0,0,0.15);
  overflow: hidden;
  margin: 16px;
  max-height: 75vh;
`;

const TextBox = styled.div`
  color: #626469;
  font-weight: 400;
`;

const Title = styled(TextBox)`
  font-size: 24px;
  letter-spacing: 0.19px;
  line-height: 28px;
  margin-bottom: 25px;
`;

const Text = styled(TextBox)`
  font-size: 16px;
  letter-spacing: 0.13px;
  line-height: 18px;
  margin-bottom: 35px;
  overflow: auto;
`;

const ButtonArea = styled.div`
  display: flex;
`;

const CancelWrapper = styled.div`
  margin-right: 5px;
`;

const SubmitWrapper = styled.div`
  margin-left: 5px;
`;

class ModalConfirmation extends React.PureComponent {

  handleCancelClick = () => this.props.onCancel();
  handleSubmitClick = () => this.props.onSubmit();

  render = () => {
    const { title, text, cancelText, submitText } = this.props;
    return (
      <Container>
        <Title>{title}</Title>
        <Text>{text}</Text>
        <ButtonArea>
          <CancelWrapper>
            <Button id={'cancel-confirmation-modal'} primary option="outline" onClick={this.handleCancelClick}>
              {cancelText}
            </Button>
          </CancelWrapper>
          <SubmitWrapper>
            <Button id={'confirm-confirmation-modal'} importance="emphasized" primary onClick={this.handleSubmitClick}>
              {submitText}
            </Button>
          </SubmitWrapper>
        </ButtonArea>
      </Container>
    );
  }
}

export default ModalConfirmation;
